import type { ZodError, ZodIssue } from "zod";
import { portalSchema } from "./portal-schema";
import type { PortalSchema } from "./portal-schema";

export interface ValidationResult {
  success: boolean;
  data?: PortalSchema;
  errors?: string[];
}

// Format Zod errors into readable strings
function formatZodErrors(error: ZodError<unknown>): string[] {
  return error.issues.map((issue: ZodIssue) => {
    const path = issue.path.join(".");
    return path ? `${path}: ${issue.message}` : issue.message;
  });
}

// Validate JSON data against portal schema
export function validatePortalSchema(data: unknown): ValidationResult {
  const result = portalSchema.safeParse(data);

  if (result.success) {
    return { success: true, data: result.data };
  }

  return {
    success: false,
    errors: formatZodErrors(result.error),
  };
}

// Parse JSON string and validate
export function parseAndValidatePortalSchema(jsonString: string): ValidationResult {
  try {
    const data = JSON.parse(jsonString);
    return validatePortalSchema(data);
  } catch {
    return {
      success: false,
      errors: ["Invalid JSON format"],
    };
  }
}
